import { useEffect } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { loadUmamiScript, trackPageView } from './umami.js'

/**
 * `LGH-043`. Exactly the six operator-console surfaces the task names —
 * matched against, not inferred from every route this app happens to
 * register. `/login`, `/reset-password`, `/kitchen-sink`, every `/customer/*`
 * route, and every other operator route not named here (`/rfq-source-
 * invites`, `/onboarding-requests`, `/demo-usage`, `/tenants/new`,
 * `/runs/:id/approve`&friends) are deliberately untracked — this task's own
 * scope, not an oversight.
 */
const TRACKED_ROUTES = ['/', '/runs', '/runs/:id', '/runs/:id/review', '/health', '/ask', '/rules']

function matchedRoutePattern(pathname: string): string | null {
  for (const pattern of TRACKED_ROUTES) {
    if (matchPath({ path: pattern, end: true }, pathname) !== null) return pattern
  }
  return null
}

/**
 * Mounted once, near the top of the router tree — `App.tsx`. Fires on every
 * navigation, but only ever SENDS an event for the six tracked patterns;
 * every other route is a silent no-op, not a filtered-out send.
 */
export function PageViewTracker() {
  const location = useLocation()

  useEffect(() => {
    const pattern = matchedRoutePattern(location.pathname)
    if (pattern === null) return
    loadUmamiScript()
    trackPageView(pattern)
  }, [location.pathname])

  return null
}
